import ILayout from "../models/layout";

export class GlobalConstants {
  public static lang = 'tr';
  //public static mainDomain: string = 'https://aktifbank2022.agencylook.org';
  //public static mainDomain: string = 'https://preprod.aktifbank.com.tr/api';
  //public static mainDomain: string =   'https://api.aktifbank.sameup.dev';
  public static mainDomain: string = 'https://www.aktifbank.com.tr/api';

  public static apiURL: string = this.mainDomain;
  public static apiCalculate: string = this.mainDomain + '/proxy/postproxy?url=';
  public static apiForm: string = this.mainDomain + '/';
  public static URL: string = 'https://www.aktifbank.com.tr';

  public static isLoaded = false;
  public static layout: ILayout;
  public static activePage: any = {};
  public static popup: any = {};
  
  constructor() { }
}
